<template>
  <div>
    <div class="pre-login-page small-pre-login-page">
      <div id="pre-login-page-logo">
        <h1 id="pre-login-page-ecase-logo">
          <ecase-logo/>
        </h1>

        <div id="pre-login-page-customer-branding">
          <div id="pre-login-page-customer-name">
            <template v-if="propertiesFetchComplete">
              {{ store.loginProperties.systemAreaName }}
            </template>
            <skeleton-paragraph v-else/>
          </div>
        </div>
      </div>

      <div>
        <slot name="header"/>
      </div>

      <div v-if="showNotifications" id="pre-login-page-system-notifications">
        <div v-if="store.loginProperties.systemMessageHtml">
          <atom-info-box priority="warning">
            <!-- eslint-disable vue/no-v-html -->
            <div v-html="store.loginProperties.systemMessageHtml"/>
          </atom-info-box>
        </div>
      </div>

      <template v-if="!propertiesFetchComplete">
        <skeleton-form/>
      </template>

      <div v-else-if="loading" class="ecase-sign-in__spinner icon-animated-spinner blue-icon delayed-loading-indicator">
        {{ loadingText }}
      </div>

      <div v-else>
        <slot name="body"/>
      </div>
    </div>

    <div id="pre-login-page-footer">
      <slot v-if="propertiesFetchComplete" name="footer"/>
    </div>
  </div>
</template>

<script>
import EcaseLogo from "authentication/components/login/components/EcaseLogo.vue";
import SkeletonForm from "authentication/components/login/skeleton/SkeletonForm.vue";
import SkeletonParagraph from "authentication/components/login/skeleton/SkeletonParagraph.vue";
import { useLoginPropertiesStore } from "authentication/stores/login-properties.store";
import AtomInfoBox from "core/components/atom/infoBox/AtomInfoBox.vue";

export default {
  components: {
    SkeletonParagraph,
    SkeletonForm,
    AtomInfoBox,
    EcaseLogo,
  },
  props: {
    loading: { type: Boolean, default: false },
    loadingText: { type: String, default: "Loading..." },
    showNotifications: { type: Boolean, default: false },
  },
  setup() {
    return { store: useLoginPropertiesStore() };
  },
  data() {
    return { propertiesFetchComplete: false };
  },
  async created() {
    await this.store.isReady();
    this.propertiesFetchComplete = true;
  },
};
</script>

<style src="./LoginLayout.scss" lang="scss"/>
